export enum ApiStoreKey {
  // Define your API's unique key to access from store here
  location = 'location',
  class = 'class',
}
